import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Item, Order} from '../models/order.model';
import {RoomType} from '../models/roomType.model';
import {CheckIn} from '../models/checkin.model';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap} from "rxjs/operators";
import { timer } from 'rxjs';
import {UserService} from "./user.service";
import { utc } from 'moment';

export interface StatElement {
    statElementDetailId: string | null;
    number: string;
    detail: string;
    detail2: string;
    detail3: string;
    detail4: string;
    [key: string]: any; // Attributs dynamiques
}


@Injectable({
  providedIn: 'root'
})
export class EndOfDayService {

  DataDetails:any = undefined;
  private hotelurl:string = environment.api+'/reservations?';
  private crmurl:string= environment.crmTest ;
  public hotelDate : any = '';



  /*
  public apiCheckIn:string = environment.api+'/checkins';
  public api:string = environment.api+'/orders';
  private createrese = environment.api+ "/reservations"
  private itemUrl:string = environment.crmTest + '/item';
  private itemOrderUrl:string = environment.crmTest +'/order/item';
  private itemOrderUrlOrder:string = environment.crmTest +'/order';




 getAllCheckinsA(){
    let url = this.hotelurl;
    if (this.convertedDateCre !== undefined ) {
      let previousDate = new Date(this.convertedDateCre);
      previousDate.setDate(this.convertedDateCre.getDate() - 1);
      let formattedPreviousDate = previousDate.toISOString().substring(0, 10);

      let nextDate = new Date(this.convertedDateCre);
      nextDate.setDate(this.convertedDateCre.getDate() + 1);
      let formattedNextDate = nextDate.toISOString().substring(0, 10);
      url = url + '&createdfrom=' + formattedPreviousDate + '&createdto=' + formattedNextDate;
    }
    if (this.checkinDate !== undefined ) {
      //console.log("this.checkinDate in service checkin", this.checkinDate);
      url = url + '&from=' + this.checkinDate ;
    }
    if (this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url = url + '&to=' + this.checkoutDate;
    }
    if(this.guestFilter!==undefined){
      url=url+'&guest='+this.guestFilter
    }
    if(this.customerFilter!==undefined){
      url=url+'&customer='+this.customerFilter
    }
    if(this.numberFilter!==undefined){
      url=url+'&boNumber='+this.numberFilter
    }
    if(this.reservationStatusFilter!==undefined){
      url=url+'&resastatus='+this.reservationStatusFilter
    }
    url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    console.log(url);
    return this.http.get(url);
    // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
  }*/




  constructor(private http: HttpClient,private userService :UserService) { }


  findclosingdates(dateHotelier: any) {
    let url = this.crmurl+'/findclosingdates?';
    
    url = url+'&selecteddate='+dateHotelier+'T00:00:00&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    return this.http.get(url);
  }

  // findclosingdatesMounth(fromdateHotelier:any,dateHotelier: any) {
  //   let url  = this.crmurl+'/closingdates/accumulated/v2?';
  //   url =  url + 'closingdatefrom='+fromdateHotelier;
  //   url = url +'&ignoredetail=true';
  //   url = url + '&closingdateto='+dateHotelier;
  //   url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
  //   return this.http.get(url);
  // }
  findclosingdatesMounthV2(fromdateHotelier:any,dateHotelier: any,Room:any) {
    let url  = this.crmurl+'/closingdates/accumulated/lite?';
    url =  url + 'closingdatefrom='+fromdateHotelier;
    url = url +'&ignoredetail=false';
    url = url + '&closingdateto='+dateHotelier;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId+'&totalroom='+Room;
    return this.http.get(url);
  }

    GetBacANDReport(fromdateHotelier:any,dateHotelier: any) {
    let url  = this.crmurl+'/closingdate/csv?';
    url =  url + 'closingdatefrom='+fromdateHotelier;
    url = url +'&ignoredetail=false';
    url = url + '&closingdateto='+dateHotelier;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    return this.http.get(url);
  }

  findclosingdatesYear(dateHotelier: any) {
    let url  = this.crmurl+'/closingdates/accumulated/v2?';
    url =  url + 'closingdatefrom=2024-11-01';
    url = url + '&closingdateto='+dateHotelier;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    return this.http.get(url);
  }



  getDepartureNotCHeckedOut(hotelDate){
    let url = this.hotelurl;

    const currentDate = new Date(hotelDate);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    // const formattedDate = `2024-03-07`; // date pour le teste
    url = url + 'to=' + formattedDate ;

    url=url+'&resastatus=2'
    url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

    console.log(url)
    return this.http.get(url);

  }

  async getDateClosedPromise(): Promise<string> {
    let url = this.crmurl + '/closing/date?';
    const date = await this.http.get<string>(url + '&group=' + JSON.parse(localStorage.getItem("userDetails")).group.groupId, { responseType: 'text' } as any).toPromise();
    this.hotelDate = date;
    return date;
  }
 getAllDeparture(hotelDate){
    let url = this.hotelurl;

    const currentDate = new Date(hotelDate);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    //const formattedDate = `2024-02-27`; // date pour le teste
    url = url + 'to=' + formattedDate ;

    url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

    console.log(url)
    return this.http.get(url);

  }
  /*
 getDateClosedPromise(): Promise<any> {
   let url = this.crmurl + '/closing/date?';
   return this.http.get<string>(url + '&group=' + JSON.parse(localStorage.getItem("userDetails")).group.groupId, { responseType: 'text' } as any).toPromise();
 }*/
  getAllArrivals(hetelDate){
    let url = this.hotelurl;

    const currentDate = new Date(hetelDate);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    // const formattedDate = `2024-02-27`; // date pour le teste
    url = url + 'from=' + formattedDate ;

    url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

    console.log(url)
    return this.http.get(url);

  }


  /*
    getArrivalsNotCHeckin(hotelDate){
      let url = this.hotelurl;

      const currentDate = new Date(hotelDate);
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      // const formattedDate = `2024-02-27`; // date pour le teste


     url = url + 'from=' + formattedDate ;

      url=url+'&resastatus=0'
      url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

      console.log(url)
      return this.http.get(url);

    }
  */
  getArrivalsNotCHeckin(hotelDate) {
    let url = this.hotelurl;
    const currentDate = new Date(hotelDate);

    if (isNaN(currentDate.getTime())) {
      console.error('Invalid date provided:', hotelDate);
      return; // Optionnel: retourner ou gérer l'erreur comme nécessaire
    }

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    url += `from=${formattedDate}&resastatus=0`;
    url += `&group=${JSON.parse(localStorage.getItem("userDetails")).group.groupId}`;

    console.log(url);
    return this.http.get(url);
  }


  getDailyTurnover(hotelDate){
    let url = this.hotelurl;

    const currentDate = new Date(hotelDate);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    url = url + 'from=' + formattedDate ;

    url=url+'&resastatus=2'
    url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

    console.log(url)
    return this.http.get(url);

  }

  putClosing(closingdate:any){
    let url =this.crmurl + '/closingdate';

    return this.http.put(url,closingdate);
  }
  getClosing(simulate:any,hotelDate:any,type?:any){
    //url = url + 'orders/closing?user=7&status=4&simulate=true&closingdate=2023-06-01';
    const currentDate = new Date(hotelDate);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    let url = this.crmurl + '/orders/closing?user='+JSON.parse(localStorage.getItem("userDetails")).userId + '&status=4&simulate='+simulate+'&closingdate='+formattedDate;
    if (type)
        url += '&type='+type;

    return this.http.get(url);
  }


PostDirety(groupId: any): Observable<any> {
  const url = `https://pmsvaleriaapi.fractalstay.com/api/housekeeping/inhouse-to-dirty?groupId=${groupId}`;
  return this.http.post(url, {});
}

 GeneretaeEcriteur(hotelDate: any) {
    // 1. Setup Current Date
    const currentDate = new Date(hotelDate);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const startfrom = `${year}-${month}-${day}`;

    // 2. Setup Previous Date (currentDate - 1 day)
    const previousDate = new Date(currentDate); // Clone it first
    previousDate.setDate(currentDate.getDate() - 1); // Subtract 1 day

    const prevYear = previousDate.getFullYear();
    const prevMonth = String(previousDate.getMonth() + 1).padStart(2, '0');
    const prevDay = String(previousDate.getDate()).padStart(2, '0');
    
    // 3. Assign
    const endfrom = `${prevYear}-${prevMonth}-${prevDay}`;

    console.log(`Start: ${startfrom}, End (Yesterday): ${endfrom}`);

    let url = this.crmurl + '/allinvoices/entries?&group=' + 
              JSON.parse(localStorage.getItem("userDetails") || '{}').group.groupId + 
              '&createdfrom=' + endfrom + 
              '&createdto=' + startfrom;
    return this.http.get(url);
}




  getRegulation(hotelDate) {
    let url = this.hotelurl;

    const currentDate = new Date(hotelDate);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    url = url + 'from=' + formattedDate ;

    url=url+'&resastatus=2'
    url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

    console.log(url)
    return this.http.get(url);


  }

  getAllClosing() {
    let url =this.crmurl + '/closingdates';
    url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    return this.http.get(url);
  }
    getClosingDay(date : any,type?:number) {
        let url =this.crmurl + '/closingdate?';
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId+'&closingdate='+date;

        return this.http.get(url);
    }
    getClosingDayRoom(date : any, Room:any) {
        let url =this.crmurl + '/closingdate?';
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId+'&closingdate='+date+'&totalroom='+Room;

        return this.http.get(url);
    }

    getstatisticMounths(dateA : any,dateB : any) {
      let url =this.crmurl + '/orders/item/count?type=Customer&status=4';
      url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      url =  url+"&startservice="+dateA+"&startendservice="+dateA; 
      url = url+ "&endservice="+dateB;
      const endDate = new Date(dateB);
      const endDatePlusOneMonth = new Date(endDate);
      endDatePlusOneMonth.setMonth(endDate.getMonth() + 1);
      // Format the new date as YYYY-MM-DD
      const formattedEndDatePlusOneMonth = endDatePlusOneMonth.toISOString().split('T')[0];
      url =  url + '&endendservice='+formattedEndDatePlusOneMonth;
      return this.http.get(url);
  }
  getHetelDayi(){
    let hotelDate = null;
      if (this.hotelDate)
        hotelDate = new Date(this.hotelDate);
      else
      {
        this.getDateClosed().subscribe(data=>hotelDate=new Date(data));  // Appelez la méthode getDateClosed() si this.hotelDate est undefined
      }
      return hotelDate.toISOString();

  }
  getHotelDay(): Observable<string> {
    if (this.hotelDate) {
        // If hotelDate is already set
        const hotelDate = new Date(this.hotelDate); // Convert hotelDate to a Date object
        return of(hotelDate.toISOString()); // Return the date as an Observable<string>
    } else {
        // If hotelDate is undefined, fetch the date asynchronously
        return this.getDateClosed();
    }
}

   
    getLastHotelDay(): Observable<string> {
      if (this.hotelDate) {
          // If hotelDate is already set
          const hotelDate = new Date(this.hotelDate);  // Convert hotelDate to a Date object
          hotelDate.setDate(hotelDate.getDate() - 1);  // Subtract one day
          return of(hotelDate.toISOString());  // Return the date as an Observable<string>
      } else {
          // If hotelDate is undefined, fetch the date asynchronously
          return this.getDateClosed().pipe(
              map((data:string) => {
                  const hotelDate = new Date(data);  // Convert the fetched date to a Date object
                  hotelDate.setDate(hotelDate.getDate() - 1);  // Subtract one day
                  return hotelDate.toISOString();  // Return the date as a string
              })
          );
      }
  }
  

    setHetelDay(response: any) {
    this.hotelDate = response;

  }
  getDateClosed(): Observable<string> {
    let url = this.crmurl + '/closing/date?';
    return this.http.get(url+'&group='+ JSON.parse(localStorage.getItem("userDetails")).group.groupId , { responseType: 'text' }).pipe(
        map((response: ArrayBuffer | string) => {
          if (typeof response === 'string') {
            this.setHetelDay(response);
            return response;
          } else {
            // Convert ArrayBuffer to string
            return new TextDecoder().decode(response);
          }
        }),
        catchError(error => {
          const errorMessage = 'Error fetching date closed';
          console.error(errorMessage, error);
          return throwError(errorMessage);
        })
    );
  }

    getClosingDetails(simulate: any, hotelDate: any, type?: any) {
        const currentDate = new Date(hotelDate);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        let url =
            this.crmurl +
            '/orders/closing?user=' +
            JSON.parse(localStorage.getItem('userDetails')!).userId +
            '&status=4&simulate=' +
            simulate +
            '&closingdate=' +
            formattedDate;
        if (type) {
            url += '&type=' + type;
        }

        return this.http.get(url).pipe(
            map((data: any) => {
                // Transformer uniquement `data.statElement` sans toucher au reste
                if (data.statElement) {
                    data.statElement = this.transformStatElement(data.statElement);
                }
                return data;
            })
        );
    }

// Transformation de `statElement`
    private transformStatElement(statElement: any[]): any[] {
        const groupedData: { [key: string]: any } = {};

        statElement.forEach(item => {
            const number = item.number;

            if (!groupedData[number]) {
                groupedData[number] = {
                    statElementDetailId: item.statElementDetailId,
                    number: item.number,
                    detail: item.detail,
                    detail2: item.detail2,
                    detail3: item.detail3,
                    detail4: item.detail4,
                };
            }

            groupedData[number][item.element] = item.value;
        });

        return Object.values(groupedData);
    }


    getAccumulatedClosingDate(fromDate : any, toDate : any) {
      let url =this.crmurl + '/closingdates/accumulated?';
      url = url+'group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId+'&closingdatefrom='+fromDate+'&closingdateto='+toDate;

      return this.http.get(url);
    }
     getAccumulatedClosingDateNew(): Observable<any> {
        const today = new Date();
        // 📅 D - 1
        const toDate = new Date(today);
        toDate.setDate(toDate.getDate() - 1);

        // 📅 D - 30
        const fromDate = new Date(today);
        fromDate.setDate(fromDate.getDate() - 30);

        // Format YYYY-MM-DD
        const formatDate = (date: Date) => date.toISOString().split('T')[0];

        const formattedFromDate = formatDate(fromDate);
        const formattedToDate = formatDate(toDate);

        const groupId = JSON.parse(localStorage.getItem("userDetails"))?.group?.groupId;

        const url = `${this.crmurl}/closingdates/accumulated/v2?group=${groupId}&closingdatefrom=${formattedFromDate}&closingdateto=${formattedToDate}`;

        return this.http.get(url);
     }


    /*
        private transformData(data: any[]): StatElement[] {
            const groupedData: { [key: string]: any } = {};

            data.forEach(item => {
                const number = item.number;

                if (!groupedData[number]) {
                    groupedData[number] = {
                        statElementDetailId: item.statElementDetailId,
                        number: item.number,
                        detail: item.detail,
                        detail2: item.detail2,
                        detail3: item.detail3,
                        detail4: item.detail4
                    };
                }

                groupedData[number][item.element] = item.value;
            });

            return Object.values(groupedData) as StatElement[];
        }
    */
    private data: any = {};

    setData(value: any) {
        this.data = value;
    }

    getData() {
        return this.data;
    }

    // Méthode pour transférer les données vers localStorage temporairement
    prepareForNewWindow() {
        localStorage.setItem('TempData', JSON.stringify(this.data));
    }

    // Méthode pour charger les données depuis localStorage dans la nouvelle fenêtre
    loadFromNewWindow() {
        const tempData = localStorage.getItem('TempData');
        if (tempData) {
            this.data = JSON.parse(tempData);
            localStorage.removeItem('TempData'); // Nettoyage après chargement
        }
    }


    GetBackAndRepportBack(hotelDate:any){
      const currentDate = new Date(hotelDate);
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      let url = this.crmurl + '/daily-bac/one?groupId='+JSON.parse(localStorage.getItem("userDetails")).group.groupId+'&date='+formattedDate
      return this.http.get(url);
    }
    
    getItemsService(createdfrom: string, createdto: string, group: number, producttype: number): Observable<any> {
      const url = `https://crmapi.valeriahotels.com/api/items/byservice?servicefrom=${createdfrom}&serviceto=${createdto}&group=${group}&producttype=${producttype}`;
      return this.http.get(url);
    } 
    
    findclosingdatesMounth(fromdateHotelier:any,dateHotelier: any) {
      let url  = this.crmurl+'/closingdates/accumulated/v2?';
      url =  url + 'closingdatefrom='+fromdateHotelier;
      url = url +'&ignoredetail=false';
      url = url + '&closingdateto='+dateHotelier;
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      return this.http.get(url);
    }

    findclosingdatesMounthAA(fromdateHotelier:any,dateHotelier: any) {
      let url  = this.crmurl+'/closingdates/accumulated/v2?';
      url =  url + 'closingdatefrom='+fromdateHotelier;
      url = url +'&ignoredetail=true';
      url = url + '&closingdateto='+dateHotelier;
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      return this.http.get(url);
    }
}
